import { callApi } from '../utils';
import { routes } from '../../lib/routes';
import { SerializedDevicesTestingRecord, DevicesTestingStatusMeta } from '../../model/devicesTestingForm';
import { Channel } from 'client/model/skill';

export const getDevicesTestingRecordStatus = (skillId: string, channel: Channel) => {
    return callApi<DevicesTestingStatusMeta>({
        method: 'GET',
        url: routes.app.appStoreApi(`/apps/${skillId}/testing-date/status`),
        queryParams: { channel },
    });
};

export const saveDevicesTestingOptions = (skillId: string, body: SerializedDevicesTestingRecord) => {
    return callApi<SerializedDevicesTestingRecord>({
        method: 'POST',
        url: routes.app.api(`/skills/${skillId}/testing-date`),
        data: body,
    });
};
